// extracted by mini-css-extract-plugin
export var carrierIcon = "_xj-0";
export var carrierLogo = "_xj-1";
export var detailsSection = "_xj-2";